const TCCStatuses = {
    NOT_STARTED: 'Não iniciado',
    IN_PROGRESS: 'Em andamento',
    FINISHED: 'Finalizado',
    SUBMITTED: 'Submetido',
    APPROVED: 'Aprovado',
    REJECTED: 'Reprovado',
};

export default TCCStatuses;



// WEBPACK FOOTER //
// ./src/components/tccs/tcc-statuses.js